import moment from 'moment'; 

const formatDate = (date) => {
    return moment(new Date(date + 'T00:00:01')).format('MM-DD-YYYY')
}

export default formatDate; 